import DynamicButton from './DynamicButton';

export default DynamicButton;
